import React, { FunctionComponent } from 'react'
import VerticalSummaryReportingContainer from './ByVertical'

const VerticalSummaryContainer: FunctionComponent = () => {
  return <VerticalSummaryReportingContainer />
}

export default VerticalSummaryContainer
